import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../../../components/Navbar";
import { useAddAssignmentMutation } from "../../../features/assignments/assignmentApi";
import { useGetVideosQuery } from "../../../features/videos/videoApi";

const AddAssignment = () => {
  const navigate = useNavigate();
  const [addAssignment, { isLoading }] = useAddAssignmentMutation();
  const { data: videos } = useGetVideosQuery();
  const [state, setState] = useState({
    title: "",
    video_id: "",
    video_title: "",
    totalMark: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("🚀 ~ file: AddVideo.js:6 ~ AddVideo ~ e", state);

    addAssignment(state);
    navigate("/admin/assignments");
  };
  const handleSelectVideo = (videoID) => {
    const video = videos.find((item) => item.id === parseInt(videoID));
    setState((prevState) => ({
      ...prevState,
      video_id: video.id,
      video_title: video.title,
    }));
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }
  return (
    <>
      <Navbar />
      <section className="py-6 bg-primary">
        <div className="mx-auto max-w-7xl px-5 lg:px-0">
          <div className="px-3 lg:px-0 py-20 bg-opacity-10">
            <div className="w-full flex items-center">
              <h1 className="text-2xl font-bold">Add New Assignment</h1>
              <Link to="/admin/assignments" className="btn ml-auto">
                All Assignment
              </Link>
            </div>
            <div className="overflow-x-auto mt-4">
              <form onSubmit={handleSubmit}>
                <div className="flex flex-row gap-4 mb-8">
                  <div className="flex flex-col input-group">
                    <label htmlFor="title">Title</label>
                    <input
                      type="text"
                      name="title"
                      id="title"
                      placeholder="Assignment 1 - Implement Debounce Fun..."
                      value={state.title}
                      required
                      onChange={handleChange}
                    />
                  </div>
                  <div className="flex flex-col input-group">
                    <label htmlFor="video_id">Select Video</label>
                    <select
                       name="video_id"
                       id="video_id"
                       required={true}
                       value={state.video_id}
                       onChange={(e) => handleSelectVideo(e.target.value)}
                    >
                      <option value hidden selected>
                        Select Video
                      </option>
                      {videos?.map((item) => (
                        <option value={item.id} key={item.id}>
                          {item?.title}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="flex flex-row gap-4 mb-8">
                  <div className="flex flex-col input-group">
                    <label htmlFor="totalMark">Total Mark</label>
                    <input
                      type="number"
                      name="totalMark"
                      id="totalMark"
                      placeholder="100"
                      value={state.totalMark}
                      required
                      onChange={(e) =>
                        setState({
                          ...state,
                          totalMark: parseInt(e.target.value),
                        })
                      }
                    />
                  </div>
                </div>
                <button className="group relative flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500 mx-auto">
                  Add New Assignment
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AddAssignment;
